import React from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  FormGroup,
  Form,
  Label,
  Row,
  Col,
  Button,
  DropdownItem,
} from 'reactstrap'
import get from 'lodash/get'
import styled from 'styled-components'
import { FONTS, COLORS } from '../../../../constants'

class ProjectSubmitRequestDetail extends React.Component {
  render() {
    const open = get(this.props, 'open')
    const toggle = get(this.props, 'toggle')
    return (
    /* eslint no-underscore-dangle: 0 */
      <Modal
        size='lg'
        isOpen={ open }
        toggle={ () => toggle() }
      >
        <ModalHeader toggle={ () => toggle() }>
          <HeadLabel>Project Information</HeadLabel>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm="12">
              <Form onSubmit={ (e) => e.preventDefault() }>
                <FormGroup>
                  <Container>
                    <Row>
                      <Col sm={ 4 }>
                        <TextLabel >Project Manager</TextLabel>
                      </Col>
                      <Col sm={ 8 }>
                        { get(this.props, 'request.project_managers.length') === 0 && '-' }
                        { get(this.props, 'request.project_managers', []).map(m => {
                          return (<TextInfo>{ m.name }</TextInfo>)
                        })
                        }
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={ 4 }>
                        <TextLabel >Additional Project Manager</TextLabel>
                      </Col>
                      <Col sm={ 8 }>
                        { get(this.props, 'request.project_approvers.length') === 0 && '-' }
                        { get(this.props, 'request.project_approvers', []).map(a => {
                          return (<TextInfo>{ a.name}</TextInfo>)
                        })
                        }
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={ 4 }>
                        <TextLabel >Project Type</TextLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <TextInfo>{ get(this.props, 'request.project_type')}</TextInfo>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={ 4 }>
                        <TextLabel >Client</TextLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <TextInfo>{ get(this.props, 'request.client')}</TextInfo>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={ 4 }>
                        <TextLabel >Project Name</TextLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <TextInfo>{ get(this.props, 'request.project_name')}</TextInfo>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={ 4 }>
                        <TextLabel >PM Supervisor</TextLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <TextInfo>{ get(this.props, 'request.pm_supervisor')}</TextInfo>
                      </Col>
                    </Row>
                    <DropdownItem divider />
                    <Row>
                      <Col sm={ 4 }>
                        <TextLabel >Company</TextLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <TextInfo>{ get(this.props, 'request.company')}</TextInfo>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={ 4 }>
                        <TextLabel >LOB</TextLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <TextInfo>{ get(this.props, 'request.lob')}</TextInfo>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={ 4 }>
                        <TextLabel >Department</TextLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <TextInfo>{ get(this.props, 'request.department')}</TextInfo>
                      </Col>
                    </Row>
                    <DropdownItem divider />
                    <Row>
                      <Col sm={ 4 }>
                        <TextLabel >Dates</TextLabel>
                      </Col>
                      <Col sm={ 2 }>
                        <ColDate>
                          <NormalLabel>Starts On</NormalLabel>
                          <TextInfo>{ get(this.props, 'request.start_date')}</TextInfo>
                        </ColDate>
                      </Col>
                      <Col sm={ 1 } style={ { paddingBottom: '10px', display: 'flex' } }>
                        <NormalLabel>to</NormalLabel>
                      </Col>
                      <Col sm={ 2 }>
                        <ColDate>
                          <NormalLabel>Ends On</NormalLabel>
                          <TextInfo>{ get(this.props, 'request.end_date')}</TextInfo>
                        </ColDate>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={ 4 }>
                        <TextLabel >Modified by</TextLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <TextInfo>{ get(this.props, 'request.modified_by')}</TextInfo>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={ 4 }>
                        <TextLabel >Modified date</TextLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <TextInfo>{ get(this.props, 'request.modified')}</TextInfo>
                      </Col>
                    </Row>
                    <DropdownItem divider />
                    <Row style={ {
                      marginTop: 10,
                      backgroundColor: '#EBEBEB',
                      padding: '1%',
                      paddingLeft: 0,
                    } }
                    >
                      <Col sm={ 4 }>
                        <TextLabel>{ `PM's Remark` }</TextLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <TextInfo>{ get(this.props, 'request.remark_request_user')}</TextInfo>
                      </Col>
                    </Row>
                  </Container>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Message>View project available only on desktop mode</Message>
          <ViewButton
            color='success'
            onClick={ () => this.props.viewProject(get(this.props, 'request.canApprove')) }
          >View Project</ViewButton>
        </ModalFooter>
      </Modal>
    )
  }
}

ProjectSubmitRequestDetail.propTypes = {
  viewProject: PropTypes.func,
}
ProjectSubmitRequestDetail.defaultProps = {
  viewProject: () => {},
}

export default ProjectSubmitRequestDetail

const TextInfo = styled.p`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.NORMAL_SIZE};
`
const Message = styled(TextInfo)`
  display: none;
  @media (max-width: 767.98px) {
    display: flex;
  }
`
const ViewButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
  @media (max-width: 767.98px) {
    display: none;
  }
`
const HeadLabel = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.TITLE_SIZE};
  color: ${COLORS.PRIMARY_RED};
  padding-left: 15px;
`
const TextLabel = styled.p`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.NORMAL_SIZE};
  color: ${COLORS.BLACK};
`
const NormalLabel = styled.p`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.NORMAL_SIZE};
  color: ${COLORS.BLACK};
`
const ColDate = styled(Col)`
  width : 100%;
  height : 55%;
  padding-left: 0;
  padding-right: 0;
`



// WEBPACK FOOTER //
// ./src/components/project-information/form/project-submit-request-detail/index.js